export const EducationLevel = Object.freeze({
	"-2": "Aucun diplôme",
	"-1": "CAP, BEP, Bac pro",
	"0": "Baccalauréat",
	"2": "Bac+2, BTS",
	"3": "Bac+3, Bachelor, Licence, BUT",
	"4": "Bac+4, Master 1",
	"5": "Bac+5, Master, Ingénieur",
	"8": "Bac+8, Doctorat",
	"9": "Médecin",
	"2.2": "Bac+2, BTS",
	"3.3": "Bac+3, Bachelor, Licence, BUT",
	"4.4": "Bac+4, Master 1",
	"4.5": "Bac+4, Master 1",
	"5.5": "Bac+5, Master, Ingénieur",
	"8.8": "Bac+8, Doctorat",
	"9.9": "Médecin"

});

export const Contract = Object.freeze({
	"permanent": "CDI",
	"fixed-term": "CDD",
	"apprenticeship": "Alternance",
	"internship": "Stage",
	"civic": "Service civique",
	"fr-vie": "VIE",
	"freelance": "Indépendant",
	"training": "Formation",
	"coaching": "Coaching",
	"public-permanent": "Permanent",
	"public-non-permanent": "Non permanent"
});

export const Remote = Object.freeze({
	"regular": "Alternance télétravail / sur site",
	"occasional": "Télétravail toléré ponctuellement",
	"forbidden": "Aucun télétravail possible",
	"full": "Télétravail total"
});


export const Genders = Object.freeze([
	{ "key": "male" },
	{ "key": "female" },
	{ "key": "undisclosed" }
]);

export const Countries = Object.freeze([
	{ "key": "france", cp: { rx: "^\\d{5}$", type: 'text', minLen: 5, maxLen: 5 } },
	{ "key": "afghanistan" },
	{ "key": "south africa" },
	{ "key": "albania" },
	{ "key": "algeria" },
	{ "key": "germany" },
	{ "key": "andorra" },
	{ "key": "angola" },
	{ "key": "antigua and barbuda" },
	{ "key": "saudi arabia" },
	{ "key": "argentina" },
	{ "key": "armenia" },
	{ "key": "australia" },
	{ "key": "austria" },
	{ "key": "azerbaijan" },
	{ "key": "bahamas" },
	{ "key": "bahrain" },
	{ "key": "bangladesh" },
	{ "key": "belgium" },
	{ "key": "belize" },
	{ "key": "benin" },
	{ "key": "bhutan" },
	{ "key": "belarus" },
	{ "key": "burma (myanmar)" },
	{ "key": "bolivia" },
	{ "key": "bosnia and herzegovina" },
	{ "key": "botswana" },
	{ "key": "brazil" },
	{ "key": "brunei" },
	{ "key": "bulgaria" },
	{ "key": "burkina" },
	{ "key": "burundi" },
	{ "key": "cambodia" },
	{ "key": "cameroon" },
	{ "key": "canada" },
	{ "key": "cape verde" },
	{ "key": "chile" },
	{ "key": "china" },
	{ "key": "cyprus" },
	{ "key": "colombia" },
	{ "key": "comoros" },
	{ "key": "congo" },
	{ "key": "korea, north" },
	{ "key": "korea, south" },
	{ "key": "costa rica" },
	{ "key": "ivory coast" },
	{ "key": "croatia" },
	{ "key": "cuba" },
	{ "key": "denmark" },
	{ "key": "djibouti" },
	{ "key": "dominica" },
	{ "key": "egypt" },
	{ "key": "el salvador" },
	{ "key": "united arab emirates" },
	{ "key": "ecuador" },
	{ "key": "eritrea" },
	{ "key": "spain" },
	{ "key": "estonia" },
	{ "key": "ethiopia" },
	{ "key": "russian federation" },
	{ "key": "fiji" },
	{ "key": "finland" },
	{ "key": "gabon" },
	{ "key": "gambia" },
	{ "key": "georgia" },
	{ "key": "ghana" },
	{ "key": "greece" },
	{ "key": "grenada" },
	{ "key": "guatemala" },
	{ "key": "guinea" },
	{ "key": "equatorial guinea" },
	{ "key": "guinea-bissau" },
	{ "key": "guyana" },
	{ "key": "haiti" },
	{ "key": "honduras" },
	{ "key": "hungary" },
	{ "key": "mauritius" },
	{ "key": "marshall islands" },
	{ "key": "solomon islands" },
	{ "key": "samoa" },
	{ "key": "india" },
	{ "key": "indonesia" },
	{ "key": "iraq" },
	{ "key": "iran" },
	{ "key": "ireland" },
	{ "key": "iceland" },
	{ "key": "israel" },
	{ "key": "italy" },
	{ "key": "jamaica" },
	{ "key": "japan" },
	{ "key": "jordan" },
	{ "key": "kazakhstan" },
	{ "key": "kenya" },
	{ "key": "kuwait" },
	{ "key": "kyrgyzstan" },
	{ "key": "barbados" },
	{ "key": "laos" },
	{ "key": "united states" },
	{ "key": "lesotho" },
	{ "key": "latvia" },
	{ "key": "lebanon" },
	{ "key": "liberia" },
	{ "key": "libya" },
	{ "key": "liechtenstein" },
	{ "key": "lithuania" },
	{ "key": "luxembourg" },
	{ "key": "macedonia" },
	{ "key": "madagascar" },
	{ "key": "malawi" },
	{ "key": "malaysia" },
	{ "key": "maldives" },
	{ "key": "mali" },
	{ "key": "malta" },
	{ "key": "morocco" },
	{ "key": "mauritania" },
	{ "key": "mexico" },
	{ "key": "micronesia" },
	{ "key": "moldova" },
	{ "key": "monaco" },
	{ "key": "mongolia" },
	{ "key": "montenegro" },
	{ "key": "mozambique" },
	{ "key": "namibia" },
	{ "key": "nauru" },
	{ "key": "nepal" },
	{ "key": "nicaragua" },
	{ "key": "niger" },
	{ "key": "nigeria" },
	{ "key": "norway" },
	{ "key": "new zealand" },
	{ "key": "oman" },
	{ "key": "uganda" },
	{ "key": "uzbekistan" },
	{ "key": "pakistan" },
	{ "key": "palau" },
	{ "key": "palestine" },
	{ "key": "panama" },
	{ "key": "papua new guinea" },
	{ "key": "paraguay" },
	{ "key": "netherlands" },
	{ "key": "peru" },
	{ "key": "philippines" },
	{ "key": "poland" },
	{ "key": "portugal" },
	{ "key": "qatar" },
	{ "key": "central african republic" },
	{ "key": "kiribati" },
	{ "key": "congo, democratic republic of" },
	{ "key": "dominican republic" },
	{ "key": "czech republic" },
	{ "key": "romania" },
	{ "key": "united kingdom" },
	{ "key": "rwanda" },
	{ "key": "saint vincent and the grenadines" },
	{ "key": "saint kitts and nevis" },
	{ "key": "san marino" },
	{ "key": "saint lucia" },
	{ "key": "sao tome and principe" },
	{ "key": "senegal" },
	{ "key": "serbia" },
	{ "key": "seychelles" },
	{ "key": "sierra leone" },
	{ "key": "singapore" },
	{ "key": "slovakia" },
	{ "key": "slovenia" },
	{ "key": "somalia" },
	{ "key": "sudan" },
	{ "key": "south sudan" },
	{ "key": "sri lanka" },
	{ "key": "sweden" },
	{ "key": "switzerland" },
	{ "key": "suriname" },
	{ "key": "swaziland" },
	{ "key": "syria" },
	{ "key": "tajikistan" },
	{ "key": "tanzania" },
	{ "key": "chad" },
	{ "key": "thailand" },
	{ "key": "east timor" },
	{ "key": "togo" },
	{ "key": "tonga" },
	{ "key": "trinidad and tobago" },
	{ "key": "tunisia" },
	{ "key": "turkmenistan" },
	{ "key": "turkey" },
	{ "key": "tuvalu" },
	{ "key": "ukraine" },
	{ "key": "uruguay" },
	{ "key": "vanuatu" },
	{ "key": "vatican city" },
	{ "key": "venezuela" },
	{ "key": "vietnam" },
	{ "key": "yemen" },
	{ "key": "zambia" },
	{ "key": "zimbabwe" }
]);
